import { Component, OnInit } from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Observable} from '../../../../../../node_modules/rxjs';
import {DataService} from '../../../../Services/data.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ResponseModel} from '../../../../DataModels/response-model';
import {ItemGroupModel} from '../../../../DataModels/item-group-model';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-item-group-form',
  templateUrl: './item-group-form.component.html',
  styleUrls: ['./item-group-form.component.scss'],
  standalone: false
})
export class ItemGroupFormComponent implements OnInit {

  itemGroupID;
  itemGroup: ItemGroupModel;
  itemGroupForm: UntypedFormGroup;
  itemType$: Observable<ItemGroupModel[]>;
  nonParentedGroupList: ItemGroupModel[];
  submitted = false;
  disableDelete = false;
  originalSnapshot: any = {};

  buttonConfig: any = {
    save: true,
    close: true,
    reset: true,
    delete: true,
    saveNew: true,
    saveClose: true,
    print: false,
  };

  constructor(
      private table: DataService,
    private notification: BsToastService,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private confirmDialogService: ConfirmDialogService,
    private titleService: Title
  ) {
    this.createForm();
    this.itemGroupID = this.route.snapshot.params.id;
  }

  get f() {
    return this.itemGroupForm.controls;
  }

  createForm() {
    this.itemGroupForm = this.formBuilder.group({
      id: new UntypedFormControl(''),
      name: new UntypedFormControl(''),
      parent_id: new UntypedFormControl(''),
      active: new UntypedFormControl(true),
      allow_edit: new UntypedFormControl(true),
    });
  }

  ngOnInit() {
    this.titleService.setTitle($localize`:Item Group @@itemGroup:Item Group`);
    this.LoadNonParentedGroups();
    this.table.getApiListData('item_group', '?pageNumber=0&pageSize=999999').subscribe((res: any) => {
      this.itemType$ = res.Data;
    });
    if (this.itemGroupID) {
      this.LoadData();
      this.buttonConfig.reset = false;
    } else {
      Promise.resolve().then(() => {
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      });
    }
  }

  private LoadData() {
    this.table.getData('item_group', this.itemGroupID).subscribe(
      (result) => {
        this.itemGroup = result;
        // console.log(this.itemGroup.allow_edit);
        if (!this.itemGroup.allow_edit) {
          this.disableDelete = true;
        }
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      },
      () => {
        this.itemGroupForm.patchValue(this.itemGroup);
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      }
    );
  }

  private LoadNonParentedGroups() {
    this.table.getApiListData('item_group', '?pageNumber=0&pageSize=999999').subscribe(
      (result: ResponseModel) => {
        const tmpArray: ItemGroupModel[] = result.Data;
        this.nonParentedGroupList = tmpArray.filter(x => x.parent_id === '');
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      },
      () => {
      }
    );
  }

  saveClose() {
    if (this.onSave(true)) {
    }
  }

  saveNew() {
    if (this.onSave(false)) {
      this.itemGroupForm.reset();
      try {
        this.originalSnapshot = this.buildSnapshot();
      } catch {
      }
    }
  }

  resetForm() {
    this.itemGroupForm.reset();
    try {
      this.originalSnapshot = this.buildSnapshot();
    } catch {
    }
  }

  onClose() {
    this.router.navigate(['admin/item-group-list']).then();
  }

  deleteItem() {
    let retMsg = '';
    const messages: string[] = [
      $localize`:Are you sure you want to delete Item Group? @@areYouSureYouWantToDeleteItemGroup:Are you sure you want to delete Item Group?`,
      this.itemGroup.name,
    ];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        this.table.deleteDataById('item_group', this.itemGroupID).subscribe(
          (result) => {
            retMsg = result;
            // this.notification.success($localize`:Deleted @@deleted:Deleted`);
          },
          (error: HttpErrorResponse) => {
            // this.notification.error($localize`:Error @@error:Error`);
            console.log(error);
          },
          () => {
            this.onClose();
          }
        );
      },
      () => {
        this.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
      }
    );
  }

  onSave(saveClose: boolean) {
    this.submitted = true;
    if (this.itemGroupForm.invalid) {
      this.notification.showWarningToast($localize`:Form Errors! @@formErrors:Form Errors!`);
      return false;
    }
    this.itemGroup = Object.assign({}, this.itemGroupForm.value);
    if (this.itemGroupID) {
      if (this.itemGroupForm.invalid === false) {
        this.table.patch('item_group', this.itemGroupID, this.itemGroup).then(
          (result) => {
            try {
              this.originalSnapshot = this.buildSnapshot();
            } catch {
            }
            if (saveClose) {
              this.onClose();
            }
          },
          (error: HttpErrorResponse) => {
            //
            console.log(error);
          }
        );
        // return true;
      }
    } else {
      this.table.postWithPromise('item_group', this.itemGroup).then((res) => {
        // stops double posting when clicking Save
        let apiReturn: any = null;
        if (typeof res === 'object') {
          apiReturn = JSON.parse(JSON.stringify(res));
        }
        this.itemGroupID = apiReturn.id;
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
        if (saveClose) {
          this.onClose();
        }
      });

      // this.notification.success($localize`:Saved @@saved:Saved`);
      // return true;
    }
    this.submitted = false;
    return true;
  }

  buildSnapshot(): any {
    try {
      return this.itemGroupForm.getRawValue();
    } catch {
      return {};
    }
  }

  hasChanges(): boolean {
    try {
      const current = this.buildSnapshot();
      const original = this.originalSnapshot || {};
      return JSON.stringify(current) !== JSON.stringify(original);
    } catch {
      return false;
    }
  }

  checkForChanges(): boolean {
    return this.hasChanges();
  }

}
